import { FC } from "react";

import cn from "classnames";
import { Image, Button, Link } from "capitalrx-components-2.0/lib/general";
import { Logo } from "capitalrx-components-2.0/lib/general";
import { NavbarProps } from "./NavbarProps";
import { contactUsPressed } from "../../utils/contactUsPressed";
import { useGroupNumber } from "@/utils/useGroupNumber";
import { Paragraph } from "capitalrx-components-2.0/lib/typography";

import styles from "./Navbar.module.scss";
import { getBrandName, getHeaderLogo, getLogoComponentName, getSavingsBrandText } from "@/utils/branding";


const Navbar: FC<NavbarProps> = ({ className }: NavbarProps) => {
  const navbarContainerClasses = cn(styles["navbarContainer"], className);
  const groupNumber = useGroupNumber();
  const brandName = getBrandName();
  const savingsBrandText = getSavingsBrandText();
  const logoName = getLogoComponentName();
  const headerLogo = getHeaderLogo();

  const homeURL = groupNumber ? `/${groupNumber}` : "/";

  return (
    <div className={navbarContainerClasses}>
      <Link to={homeURL} className={styles.navbarLeftSide} testId="advantage-home-link">
        <Image src={headerLogo} alt={savingsBrandText} className={styles.advantageLogo} aria-hidden="true" />
        <span>{savingsBrandText}</span>
      </Link>
      <div className={styles.navbarRightSide}>
        <Paragraph className={styles.poweredBy}>
          Powered by
        </Paragraph>
        <Link to="https://cap-rx.com/" className={styles.linkToCorporate} testId="capital-rx-home-link">
          <span aria-hidden="true">
            <Logo name={logoName} testId="capital-rx-logo-footer" className={styles.capitalrxLogo} />
          </span>
          <span className="companyName">{brandName}</span>
        </Link>
        <Button className={styles.contactUsButton} appearance="primary" key={0} onClick={contactUsPressed} testId="contact-us-link">
          CONTACT US
        </Button>
      </div>
    </div>
  );
};

export default Navbar;
